<!-- eslint-disable -->
<template>
  <div class="grid_component" :class="{'single_item': response.length === 1, 'no_items': response.length === 0 && !loading}">
    <template v-for="(item, i) of response">
      <component
        ref="grid"
        class="pointer"
        :is="imports[item.templateType]"
        :key="item.id"
        @navigate="navigate"
        :entity-id="item.id + ''"
        :parent-component-data="item.componentData"
      />
    </template>
    <div style="text-align: center; width: 100%" v-if="response.length === 0 && !loading"> No Matching results</div>
    <div v-if="loading && !$device.isMobileOrTablet" v-for="(item, index) in placeholderGridData" :key="item" class="grid_item_placeholder">
      <div class="placeholder1 animated-background"></div>
      <div class="placeholder2 animated-background"></div>
      <div class="placeholder3 animated-background"></div>
    </div>
  </div>
</template>

<script>
import AbstractComponent from './AbstractComponent'

export default {
  name: 'GridComponent',
  extends: AbstractComponent,
  props: {
    user: Object,
    profileGrid: {
      default: false
    },
    filter: Object
  },
  data () {
    return {
      skipCounter: 0,
      limit: 0,
      loading: true,
      categories: '',
      response: [],
      placeholderGridData: [1, 2, 3, 4],
      imports: {},
      noMoreScroll: false,
      bottomOfWindow: false
    }
  },
  computed: {
    getItemsComponent () {
      const component = this.componentData.components
      if (component && component[0]) {
        return () => import(`../components/${component[0].type}`)
      }
      return null
    },
    getItemsComponentData () {
      return this.componentData.components[0]
    }
  },
  watch: {
    async filter (newVal, oldVal) {
      if (newVal) {
        this.loading = true
        let param = {}
        switch (newVal.type) {
          case 'priceFilter':
            if (newVal.filter) {
              param = { fromPrice: newVal.filter.fromPrice }
              if (newVal.filter.toPrice) {
                param.toPrice = newVal.filter.toPrice
              }
            } else {
              delete this.componentData.stream.fromPrice
              delete this.componentData.stream.toPrice
            }
            break
          case 'genderFilter': {
            if (newVal.filter) {
              param = { gender: newVal.filter }
            } else {
              delete this.componentData.stream.gender
            }
            break
          }
          case 'filter': {
            if (newVal.filter) {
              param = { orderBy: newVal.filter.filter }
            } else {
              delete this.componentData.stream.orderBy
            }
            break
          }
        }
        this.componentData.stream = { ...this.componentData.stream, ...param }
        this.response = []
        this.response = await this.$store.dispatch('api/genericCall', this.componentData.stream)
        this.response.forEach((itm, index) => {
          itm.templateType = this.componentData.components[0].type
          itm.componentData = this.componentData.components[0]
        })
        this.loading = false
      }
    }
  },
  beforeMount () {
    this.bucketName = 'items'
  },
  mounted () {
    this.$root.$on('on_user_ready', () => {
      this.onUserReady()
    })
    this.onUserReady().then().catch()
    this.scroll()
    this.$root.$on('categoriesFilterParams', async (categories) => {
      console.log(3333333)
      this.loading = true
      this.categories = categories
      this.componentData.stream.filterParam2 = categories
      this.response = []
      this.response = await this.$store.dispatch('api/genericCall', this.componentData.stream)
      this.response.forEach((itm, index) => {
        itm.templateType = this.componentData.components[0].type
        itm.componentData = this.componentData.components[0]
      })
      this.loading = false
    })
  },
  methods: {
    navigate (path) {
      this.$store.commit('api/storeEntities', {
        key: window.location.href,
        stream: this.componentData.stream,
        response: this.response,
        skipCounter: this.skipCounter,
        limit: this.limit,
        noMoreScroll: this.noMoreScroll,
        scrollTop: document.documentElement.scrollTop,
        date: new Date()
      })
      this.$router.push({
        path
      })
    },
    async onUserReady () {
      this.loading = true
      for (const component of this.componentData.components) {
        // BOBO
        component.type = 'GridItemComponent'
        if (!this.imports[component.type]) {
          const imprt = await import(`../components/${component.type}`)
          this.$set(this.imports, component.type, imprt.default)
        }
      }
      if (this.$store.state.api.cache[window.location.href]) {
        const cache = this.$store.state.api.cache[window.location.href]
        this.componentData.stream = cache.stream
        this.skipCounter = cache.skipCounter
        this.limit = cache.limit
        this.noMoreScroll = cache.noMoreScroll
        this.response = cache.response
        setTimeout(() => {
          document.documentElement.scrollTop = cache.scrollTop
        }, 400)
        setTimeout(() => {
          document.documentElement.scrollTop = cache.scrollTop
        }, 700)
        this.$store.commit('api/deleteCache', {
          key: window.location.href
        })
        this.loading = false
      } else {
        if (this.profileGrid) {
          this.componentData.stream.filterParam = this.$store.state.localStorage.currentUser.id
        }
        this.limit = this.componentData.stream.limit
        this.componentData.stream.skip = 0
        this.skipCounter = 0
        this.componentData.stream.cache = true
        this.response = await this.$store.dispatch('api/genericCall', this.componentData.stream)
        // eslint-disable-next-line array-callback-return
        this.response.map((itm, index) => {
          itm.templateType = this.componentData.components[0].type
          itm.componentData = this.componentData.components[0]
        })
        this.loading = false
      }
    },
    scroll () {
      window.onscroll = () => {
        if (this.noMoreScroll || !this.$refs.grid) {
          return
        }
        const lastGridElement = this.$refs.grid[this.$refs.grid.length - 1]
        if (lastGridElement) {
          const bottomOfWindow = lastGridElement.$el.offsetTop - (window.scrollY + lastGridElement.$el.offsetHeight * 2) < lastGridElement.$el.offsetHeight
          this.bottomOfWindow = bottomOfWindow
          if (bottomOfWindow && !this.loading) {
            this.loading = true
            this.skipCounter++
            this.componentData.stream.skip = this.limit * this.skipCounter
            this.fetchNextPage()
          }
        }
      }
    },
    async fetchNextPage () {
      // console.log('this.componentData.stream', this.componentData.stream)
      const response = await this.$store.dispatch('api/genericCall', this.componentData.stream)
      if (response.length === 0) {
        this.noMoreScroll = true
        this.loading = false
      } else {
        this.response = this.response.concat(response)
        // eslint-disable-next-line array-callback-return
        this.response.map((itm, index) => {
          itm.templateType = this.componentData.components[0].type
          itm.componentData = this.componentData.components[0]
        })
        this.loading = false
        /* setTimeout(() => {
          this.loading = false
        }, 1000) */
      }
    }
  }
}
</script>

<style scoped>
  .grid_component {
    display: grid;
    grid-template-columns: repeat(3, 300px);
    justify-content: center;
    grid-gap: 15px;
    grid-auto-rows: 2fr;
  }

  .mobile_design .grid_component {
    grid-template-columns: repeat(2, 50%);
    grid-gap: 0.6em;
    padding-left: 0.7em;
    padding-right: 0.7em;
  }

  .mobile_design .grid_component.single_item {
    grid-template-columns: repeat(2, 50%);
  }
  .mobile_design .grid_component.no_items {
    grid-template-columns: repeat(1, 50%);
  }
  .grid_placeholder {
    display: grid;
    grid-template-columns: repeat(3, 300px);
    justify-content: center;
    grid-gap: 15px;
    grid-auto-rows: 2fr;
    margin-left: auto;
  }

  .mobile_design .grid_placeholder {
    grid-template-columns: repeat(2, 50%);
    grid-gap: 4px;
  }
  .grid_item_placeholder {
    padding: 1em;
    position: relative;
    height: 360px;
    background-color: white;
  }
</style>
